import { createFileRoute } from '@tanstack/react-router';
import { FeaturesHero } from '@/components/astro/new-design-25/Features/FeaturesHero';
import { FeaturesUpload } from '@/components/astro/new-design-25/Features/FeaturesUpload';
import FeaturesVoiceDemo from '@/components/astro/new-design-25/Features/FeaturesVoiceDemo.tsx';
import { JumpToTheListenTo } from '@/components/astro/new-design-25/Features/JumpToTheListenTo';
import { ListenAtSpeed } from '@/components/astro/new-design-25/Features/ListenAtSpeed';
import { ListenOnTheGo } from '@/components/astro/new-design-25/Features/ListenOnTheGo';
import { OneNote } from '@/components/astro/new-design-25/Features/OneNote';
import { FAQButton } from '@/components/astro/new-design-25/ui/FAQ-Button';
import { Footer } from '@/components/astro/new-design-25/ui/Footer';
import { NavBar } from '@/components/astro/new-design-25/ui/NavBar';
import { TryListeningBanner } from '@/components/astro/new-design-25/ui/TryListeningBanner';
import { GridBackground } from '@/components/shared-ui/grid-background';
import * as m from '@/paraglide/messages';
import { hreflangLinks, seo } from '@/seo/seo';

export const Route = createFileRoute('/_marketing/features')({
  head: () => ({
    meta: [
      ...seo({
        title: m.meta_features_title(),
        description: m.meta_features_description(),
      }),
    ],
    links: [...hreflangLinks('/features')],
  }),
  component: () => (
    <>
      <a
        className='sr-only focus:not-sr-only focus:absolute focus:z-50 focus:p-4'
        href='#main-content'
      >
        {m.skip_to_main_content()}
      </a>

      <div className='relative'>
        <GridBackground>
          <div className='relative z-10'>
            <NavBar />
            <main>
              <FeaturesHero />
            </main>
          </div>
        </GridBackground>
        <div
          aria-hidden='true'
          className='absolute inset-x-0 bottom-0 h-32 bg-linear-to-t from-white to-transparent'
        />
      </div>

      <main className='relative z-20 bg-white' id='main-content'>
        <FeaturesVoiceDemo />
        <FeaturesUpload />
        <OneNote />
        <ListenAtSpeed />
        <JumpToTheListenTo />
        <ListenOnTheGo />
      </main>

      <div className='relative z-20' role='complementary'>
        <FAQButton />
        <TryListeningBanner />
        <Footer />
      </div>
    </>
  ),
});
